const locations = ['Lager', 'Tresen'];
export async function createExampleLocations(store: any) {
  const existing = store.peekAll('location');
  if (existing.length > 0) {
    return false;
  }

  for (const location of locations) {
    await store
      .createRecord('location', {
        name: location,
        active: true,
        company: store.peekRecord('company', 1),
        created_by: store.peekRecord('user', 1),
        updated_by: store.peekRecord('user', 1),
      })
      .save();
  }
}
